export const GOOGLE_OAUTH_CLIENT_ID = '875207716439-p0hoelg6vj18j7un5rhbgf08i3fphg3j.apps.googleusercontent.com';
export const GOOGLE_OAUTH_PROMPT = 'consent';
export const GOOGLE_OAUTH_COOKIE_POLICY = 'single_host_origin';
export const GOOGLE_OAUTH_ACCESS_TYPE = 'online';
